import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { BalanceResult } from './balance-result'

export class BalanceResultsRepository extends BaseRepository<BalanceResult> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'balance-results', token, cache)
    }

    async recalcBalance(personIds: string[]) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/balance-results/recalculate?token=' + this.resolvedToken,
            personIds,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
